/** The one address a customer writes to. Same value as SUPPORT_EMAIL on the
 *  backend (config.py `support_email`), which puts it in Reply-To and on the
 *  legal page. ponytail: a constant, not an API call — it changes roughly never. */
export const SUPPORT_EMAIL = 'support@priceq.io';
